const normalizeId = value => Number(value);

const isAssignedToUser = (conversation, currentUserId) =>
  normalizeId(conversation?.meta?.assignee?.id) === normalizeId(currentUserId);

export const isRestrictionEnabledForConversation = (conversation, inboxes = []) => {
  if (!conversation) return false;

  if (conversation.restrict_agent_single_open_conversation !== undefined) {
    return Boolean(conversation.restrict_agent_single_open_conversation);
  }

  const inbox = inboxes.find(
    item => normalizeId(item.id) === normalizeId(conversation.inbox_id)
  );
  return Boolean(inbox?.restrict_agent_single_open_conversation);
};

export const getAgentOpenConversationInInbox = ({
  inboxId,
  conversations = [],
  currentUserId,
  currentChat = null,
}) => {
  const normalizedInboxId = normalizeId(inboxId);

  const fromList = conversations.find(
    conversation =>
      normalizeId(conversation.inbox_id) === normalizedInboxId &&
      conversation.status === 'open' &&
      isAssignedToUser(conversation, currentUserId)
  );
  if (fromList) return fromList;

  if (
    currentChat?.id &&
    normalizeId(currentChat.inbox_id) === normalizedInboxId &&
    currentChat.status === 'open' &&
    isAssignedToUser(currentChat, currentUserId)
  ) {
    return currentChat;
  }

  return null;
};

export const canOpenConversation = ({
  conversation,
  conversations = [],
  inboxes = [],
  currentUserId,
  currentChat = null,
}) => {
  if (!conversation) return true;
  if (!isRestrictionEnabledForConversation(conversation, inboxes)) return true;
  if (conversation.status === 'resolved') return true;

  const openConversation = getAgentOpenConversationInInbox({
    inboxId: conversation.inbox_id,
    conversations,
    currentUserId,
    currentChat,
  });
  if (!openConversation) return true;

  return normalizeId(openConversation.id) === normalizeId(conversation.id);
};
